module.exports = "../../map/Kanagawa/map/agriculture/Kanagawa_AgricultureOrange_CMIP5RCP26_MIROC_No_R2081_2100.png";